var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
_global.SENTRY_RELEASE = {
  id: "6bc9c996d1a00fa457f36aacd5e294509d7b509d"
};
_global.SENTRY_RELEASES = _global.SENTRY_RELEASES || {};
_global.SENTRY_RELEASES["dubbot-react@dubbot-5f"] = {
  id: "6bc9c996d1a00fa457f36aacd5e294509d7b509d"
};